/**
 * @generated SignedSource<<ff080279b8e07f66eec80bc6bf44ec3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationMembershipContentUsagesOrderBy = "name" | "%future added value";
export type CreateMemberContentUsagesCSVDataInput = {
  contentLabelIds?: ReadonlyArray<string> | null;
  direction?: OrderDirection | null;
  excludeProductLevel?: boolean | null;
  memberHasViewed?: boolean | null;
  orderBy?: OrganizationMembershipContentUsagesOrderBy | null;
  organizationMembershipId: string;
  productIds?: ReadonlyArray<string> | null;
};
export type AdminMembersReportContentUsagesTableExportCSVButtonMutation$variables = {
  input: CreateMemberContentUsagesCSVDataInput;
};
export type AdminMembersReportContentUsagesTableExportCSVButtonMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type AdminMembersReportContentUsagesTableExportCSVButtonMutation = {
  response: AdminMembersReportContentUsagesTableExportCSVButtonMutation$data;
  variables: AdminMembersReportContentUsagesTableExportCSVButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMemberContentUsagesCSVDataResponse",
    "kind": "LinkedField",
    "name": "createMemberContentUsagesCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportContentUsagesTableExportCSVButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportContentUsagesTableExportCSVButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "59c1d6a9a4bfb50422f8ab843cd158b0",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportContentUsagesTableExportCSVButtonMutation",
    "operationKind": "mutation",
    "text": "mutation AdminMembersReportContentUsagesTableExportCSVButtonMutation(\n  $input: CreateMemberContentUsagesCSVDataInput!\n) {\n  response: createMemberContentUsagesCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f507fb5c7490393a6098eed12d499c6b";

export default node;
